module.exports = __webpack_public_path__ + "static/media/3-hybrid.0e9ad950.png";